<template>
  <el-dialog
    :visible.sync="visible"
    title="选择图标"
    :close-on-click-modal="false"
    :append-to-body="true"
    :close-on-press-escape="false"
  >
    <div class="mod-sys__menu-icon-inner" style="width:100%">
      <div class="mod-sys__menu-icon-list" style="width:100%">
        <el-button
          v-for="(item, index) in iconList"
          :key="index"
          @click="iconListCurrentChangeHandle(item)"
          :class="{ 'is-active': value === item }"
        >
          <svg class="icon-svg" aria-hidden="true">
            <use :xlink:href="`#${item}`"></use>
          </svg>
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getIconList } from "@/utils";
export default {
    props:{
        value:{
            type:String,
            default:''
        }
    },
  data() {
    return {
      visible: false,
      iconList: [],
    };
  },

  methods: {
    init() {
      this.iconList = getIconList();
      this.visible = true;
      this.$nextTick(() => {});
    },
    // 图标, 选中
    iconListCurrentChangeHandle(icon) {
      this.$emit("change", icon);
      this.visible = false;
    },
  },
};
</script>
